import { ProductCollectionResponse } from "@hermes/api-model-catalog";
import { ModelObject } from "@hermes/api-model-core";

import {
    MissingFacetContext,
    MissingFacetResult,
} from "../../constants/missing-facet-context.constant";
import {
    CombinedFacets,
    CurrentRouteData,
    Facet,
    GridData,
    GridType,
    type RouteFacet,
} from "../../store/grid.store.model";
import {
    buildFacetsWithSeoPriority,
    checkMissingFacet,
    getSelectedFilters,
    updateFiltersCrawlability,
} from "../criterias/criterias.helper";
import { gridDataFromProductCollectionResponse } from "../mappers/grid.mapper";

export const getRouteFacetFromFacet = (facet: Facet): RouteFacet => ({
    facetName: facet.facetName,
    facetNameValue: facet.facetNameValue,
    combinedFacets: facet.combinedFacets,
    enabled: facet.enabled,
    updateMetas: facet.updateMetas,
});

export const getFacetFromRouteFacetAndGridData = (
    routeFacet: RouteFacet,
    rawGridData: GridData | undefined,
): Facet => {
    const rawFacet = rawGridData?.facet;

    return {
        facetName: routeFacet.facetName,
        facetNameValue: routeFacet.facetNameValue,
        combinedFacets: routeFacet.combinedFacets,
        enabled: routeFacet.enabled,
        updateMetas: routeFacet.updateMetas,
        altPaths: rawFacet?.altPaths ?? {},
        facetTitle: rawFacet?.title ?? "",
        facetDisplayName: rawFacet?.name ?? "",
        path: rawFacet?.path ?? "",
    };
};

export const checkGridTypeFacet = (
    combinedFacets: CombinedFacets[],
    filteredFacetName: string,
): boolean =>
    combinedFacets.some((facet) => facet.facetName !== filteredFacetName);

export const computeGridType = (
    gridType: GridType,
    isFacetEnabled: boolean,
    isGridTypeFacet: boolean,
): GridType => {
    if (gridType === GridType.Search) {
        return gridType;
    }

    if (isFacetEnabled || isGridTypeFacet || gridType === GridType.Facet) {
        return GridType.Facet;
    }

    return GridType.Category;
};

export const computeMissingFacet = (
    currentRouteData: CurrentRouteData,
    facet: Facet,
    gridData: GridData,
): MissingFacetResult => {
    const filterGroupsWithCrawlableCheck = updateFiltersCrawlability(
        gridData.filterGroups ?? [],
        facet.combinedFacets,
        currentRouteData.urlParams,
    );

    const selectedFilters = getSelectedFilters(filterGroupsWithCrawlableCheck);

    return checkMissingFacet(
        selectedFilters,
        facet.combinedFacets,
        buildFacetsWithSeoPriority(gridData.filterGroups),
    );
};

export const handleMissingFacetResponse = (
    body: unknown,
    missingFacetContext: MissingFacetContext,
): MissingFacetResult | undefined => {
    const gridData = gridDataFromProductCollectionResponse(
        ModelObject.fromJsonData(body, ProductCollectionResponse),
    );

    if (!gridData) {
        return undefined;
    }

    return computeMissingFacet(
        missingFacetContext.currentRouteData,
        missingFacetContext.facet,
        gridData,
    );
};
